import styles from "../aic.module.css";
import { classMerge } from "../utility/classMerge";
import { SET_ROW_HEADER_COLUMNS } from "./functions/interface";
import { useTableContext } from "./TableContextProvider";

/**
 * Button that decreases the number of row header columns when editable.
 * Renders a disabled spacer when the decrease action is not available.
 */
export const AitRowHeaderColumnsRemove = () => {
  const { state, dispatch } = useTableContext();
  const rowHeaderColumns =
    state?.processedTableData?.rowHeaderColumns !== undefined
      ? state.processedTableData.rowHeaderColumns
      : 1;
  return !state || !state.editable || rowHeaderColumns === 0 ? (
    <div className={styles.aioxButton} />
  ) : (
    <div
      className={classMerge([styles.aioxButton, styles.aioxMinus])}
      id={`${state.id}-remove-row-header-column`}
      aria-label="Decrease row header columns"
      role="button"
      onClick={() =>
        dispatch({
          operation: SET_ROW_HEADER_COLUMNS,
          value: rowHeaderColumns - 1,
        })
      }
    />
  );
};

AitRowHeaderColumnsRemove.displayName = "AitRowHeaderColumnsRemove";
